export default __webpack_public_path__ + "static/media/helmet.7ac997a6.png";